module.exports = __webpack_public_path__ + "img/title3.2b4e1259.png";